<form
  class="link-account-form"
  [formGroup]="checkoutForm"
  (ngSubmit)="onSubmit()"
  [class.should-render-link-account-form-disclaimer]="
    shouldRenderLinkAccountFormDisclaimer
  ">
  <div class="form-wrapper">
    <rd-tcv2-membership-detail-form
      formControlName="membershipDetailForm"
      [user]="user"
      [disablePrefilledFields]="disablePrefilledFields"
      [loyaltyProgram]="loyaltyProgram"
      [formData]="formData"
      [isSubmitted]="isSubmitted$"
      [prefillForm]="prefillForm">
    </rd-tcv2-membership-detail-form>

    <p
      class="checkout-disclaimer m-0"
      *ngIf="shouldRenderLinkAccountFormDisclaimer"
      [innerHTML]="
        'transfer_v2.link_account_dialog.disclaimer'
          | translate: linkAccountDisclaimerParams
      "></p>
  </div>

  <rd-shared-button
    class="submit-button rounded-md mt-5"
    [ngClass]="{ 'lg:mt-6': shouldRenderLinkAccountFormDisclaimer }"
    [ariaLabel]="'accessibility.transfer_v2.confirm_link_account' | translate"
    [buttonClass]="'submit-button'"
    [buttonContent]="buttonContent"
    [buttonTheme]="'primary'"
    [buttonType]="'submit'"
    [isDisabled]="buttonDisabled()">
    <ng-template #buttonContent>
      <span *ngIf="loading; else loaded" class="submit-button-loading-text">
        {{
          'transfer_v2.link_account_dialog.submit_button_loading' | translate
        }}
      </span>
      <ng-template #loaded>
        <span class="submit-button-text">
          {{ 'transfer_v2.link_account_dialog.submit_button_text' | translate }}
        </span>
      </ng-template>
    </ng-template>
  </rd-shared-button>
</form>
